import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  Injector,
  OnInit,
  ViewContainerRef,
  OnDestroy,
} from '@angular/core';
import {
  BehaviouralAssessmentGraphData,
  caseDetail,
  FunctionalAssessmentModelAnswer,
  FunctionalAssessmentModelResponse,
  FunctionalAssessmentQuestion,
} from '../assesment-fba.interface';
import { finalize, Observable, Subject, take, takeUntil } from 'rxjs';
import { DrawerService } from '../../../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../../../core/constants/drawer-ids.constant';
import {
  ApiResponses,
  CaseBehaviour,
  CaseDetailModel,
} from '../../../../insights.interface';
import { LookupItem } from '../../../../../../core/models/lookup.models';
import { LoaderService } from '../../../../../../core/services/loader.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { SvgIconComponent } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { NzRadioModule, NzRadioGroupComponent } from 'ng-zorro-antd/radio';
import { NzInputModule } from 'ng-zorro-antd/input';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonService } from '../../../../../../shared/services/common.service';
import { InsightsService } from '../../../../insights.service';
import {
  NzFormControlComponent,
  NzFormItemComponent,
  NzFormModule,
} from 'ng-zorro-antd/form';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import _ from 'lodash';
import { GenderReplacePipe } from '../../../../../../core/pipes/gender-replace.pipe';
import { ScreenerResultsGraphComponent } from '../screener-results-graph/screener-results-graph.component';
import { BehaviourFunction, InsightMode } from '../../../../insights.enums';
import { ErrorResponse } from '../../../../../../core/models/error.models';
import { BehaviorFuncation } from '../assesment-fba.interface';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { PrintFbaComponent } from '../print-fba/print-fba.component';
import { OrganizationModel } from '../../../../../organizations/organization.interface';
import { OrganizationService } from '../../../../../organizations/organization.service';

@Component({
  selector: 'app-fba-assessment',
  standalone: true,
  imports: [
    NzSpinModule,
    SvgIconComponent,
    CommonModule,
    NzFormControlComponent,
    NzFormControlComponent,
    NzFormModule,
    NzFormItemComponent,
    NzDividerModule,
    ReactiveFormsModule,
    NzRadioModule,
    NzRadioGroupComponent,
    GenderReplacePipe,
    ScreenerResultsGraphComponent,
    NzButtonModule,
    NzInputModule,
  ],
  templateUrl: './fba-assessment.component.html',
  styleUrl: './fba-assessment.component.scss',
})
export class FbaAssessmentComponent implements OnInit, OnDestroy {
  behavior: CaseBehaviour = {} as CaseBehaviour;
  behaviourAssessment: FunctionalAssessmentModelAnswer[] =
    [] as FunctionalAssessmentModelAnswer[];
  caseDetail: CaseDetailModel = {} as CaseDetailModel;
  graphData: BehaviouralAssessmentGraphData[] =
    [] as BehaviouralAssessmentGraphData[];
  loading$: Observable<boolean>;
  isPrintLoading = false;
  isEdit = false;
  chartImage: string | null | undefined = null;
  fbaQuestionList!: FunctionalAssessmentQuestion[];
  private readonly destroy$ = new Subject<void>();
  BehaviourFunctionList: LookupItem[] = [];
  functionalAssessmentForm!: FormGroup;
  stepNumber = 0;
  currentQuestion = 0;
  isFinalStep = false;
  isUpdated = false;
  mode = InsightMode.VIEW;
  assesupdatedDate: string | null = null;

  constructor(
    private drawerService: DrawerService,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private commonService: CommonService,
    private insightService: InsightsService,
    private injector: Injector,
    private viewContainerRef: ViewContainerRef,
    private cd: ChangeDetectorRef,
    private orgService: OrganizationService
  ) {
    this.loading$ = this.loaderService.loading$;
    this.functionalAssessmentForm = this.fb.group({
      questions: this.fb.array([]),
      selectedOptions: [[], Validators.required],
      isAssessedFunctions: [true],
      levelEscape: [''],
      levelAttention: [''],
      isLevelEscap: [false],
      isLevelAttention: [false],
    });
    this.setupDrawerSubscription();
    this.getBehaviourQuestionList();
  }

  private setupDrawerSubscription(): void {
    this.drawerService
      .getParams<caseDetail>(DRAWER_IDS.FBA)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.caseDetail = params.caseDetail;
          this.behavior = params.behavior;
          this.chartImage = params.chartImage;
          this.mode = params.mode as InsightMode;
        }
      });
  }

  async ngOnInit() {
    await this.getMasterData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getBehaviourAssessment() {
    this.insightService
      .getBehaviourAssessment(this.behavior.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          if (response.result) {
            this.assesupdatedDate = response.result.updatedDate ?? null;
            this.behaviourAssessment =
              response.result.functionalAssessmentAnswers;
            if (this.behaviourAssessment.length === 16) {
              this.insightService.assessmentSubject.next(
                this.behaviourAssessment
              );
            }
            this.cd.detectChanges();
            if (this.behaviourAssessment.length > 0) {
              this.patchFormWithAnswers();
            }

            this.stepNumber = 0;
            this.currentQuestion =
              this.behaviourAssessment.length < 16
                ? this.behaviourAssessment.length
                : 15;
            if (this.currentQuestion === 15) {
              this.isFinalStep = true;
            }
          }
        },
        error: error => {
          this.loaderService.hide();
          this.commonService.notify('error', error.message);
        },
      });
  }
  get generateRandomId(): string {
    const randomId = Math.floor(100000 + Math.random() * 900000);
    return randomId.toString();
  }

  getBehaviourQuestionList() {
    this.loaderService.show();
    this.insightService
      .getBehvaiourAssessmentLookup()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          if (response.result) {
            this.fbaQuestionList =
              response.result.functionalAssessmentQuestions;
            this.addQuestions();
          }
          this.getBehaviourAssessment();
        },
        error: error => {
          this.loaderService.hide();
          this.commonService.notify('error', error.message);
        },
      });
  }

  patchFormWithAnswers() {
    const answers = this.behaviourAssessment;
    // Iterate over the answers array to patch the form
    answers.forEach((answerData: FunctionalAssessmentModelAnswer) => {
      const { functionalAssessmentQuestionId, functionalAssessmentAnswerId } =
        answerData;

      // Find the corresponding form group for the question
      const questionControl = this.questions.controls.find(
        group =>
          group.value.functionalAssessmentQuestionId ===
          functionalAssessmentQuestionId
      );
      // If the question is found, patch its 'answer' field
      if (questionControl) {
        questionControl.patchValue({
          functionalAssessmentAnswerId: functionalAssessmentAnswerId,
        });
      }
    });
  }

  async getMasterData() {
    this.loaderService.show();
    await Promise.all([
      this.commonService.getDataByType('BehaviourFunction').toPromise(),
    ])
      .then(
        ([BehaviourFunctionList]: [ApiResponses<LookupItem> | undefined]) => {
          this.BehaviourFunctionList = BehaviourFunctionList
            ? BehaviourFunctionList.result
            : [];
          const selectedBehaviorFuncations = this.behavior.behaviorFunction;
          if (
            selectedBehaviorFuncations &&
            selectedBehaviorFuncations.length > 0
          ) {
            const behaviorFunctionIds = selectedBehaviorFuncations.map(
              item => item.behaviorFunctionId
            );
            this.functionalAssessmentForm.patchValue({
              selectedOptions: behaviorFunctionIds,
            });

            this.stepNumber = 4;
            this.isEdit = true;
          }
          this.loaderService.hide();
        }
      )
      .catch(() => this.loaderService.hide())
      .finally(() => this.loaderService.hide());
  }

  get questions(): FormArray {
    return this.functionalAssessmentForm.get('questions') as FormArray;
  }

  get behaviorQuestionControl(): FormGroup[] {
    return this.questions?.controls as FormGroup[];
  }

  // Add the questions and answers to the form array
  addQuestions() {
    this.fbaQuestionList.forEach(question => {
      const questionGroup = this.fb.group({
        functionalAssessmentQuestionId: [question.id],
        functionalAssessmentAnswerId: [null, Validators.required], // Default answer (could be null or empty string)
      });

      // Adding each question's FormGroup to the form array
      this.questions.push(questionGroup);
    });
  }

  edit() {
    this.isEdit = false;
    this.stepNumber = 0;
    this.currentQuestion = 0;
    this.isFinalStep = false;
  }

  getFuncations() {
    const formArray: number[] =
      this.functionalAssessmentForm.value.selectedOptions;
    return _.chain(this.BehaviourFunctionList)
      .filter(option => _.includes(formArray, option.id))
      .map('value')
      .value();
  }

  getFuncationsString() {
    return this.getFuncations().join(', ');
  }

  getLevelFuncations(funcationVal: string, value: string) {
    if (value === 'Both') {
      const both = _.chain(this.BehaviourFunctionList)
        .filter(
          record =>
            (_.includes(record.value, 'Peers') ||
              _.includes(record.value, 'Adults')) &&
            _.includes(record.value, funcationVal)
        )
        .map('id')
        .value();
      const currentSelectedOptions =
        this.functionalAssessmentForm.value.selectedOptions || [];
      // Merge both arrays, ensuring there are no duplicates
      const updatedSelectedOptions = _.uniq([
        ...currentSelectedOptions,
        ...both,
      ]);
      this.functionalAssessmentForm.patchValue({
        selectedOptions: updatedSelectedOptions,
      });
    } else {
      const selected = _.chain(this.BehaviourFunctionList)
        .filter(
          record =>
            _.includes(record.value, value) &&
            _.includes(record.value, funcationVal)
        )
        .map('id')
        .value();

      const currentSelectedOptions =
        this.functionalAssessmentForm.value.selectedOptions || [];

      // Merge both arrays, ensuring there are no duplicates
      const updatedSelectedOptions = _.uniq([
        ...currentSelectedOptions,
        ...selected,
      ]);
      this.functionalAssessmentForm.patchValue({
        selectedOptions: updatedSelectedOptions,
      });
      this.functionalAssessmentForm.patchValue({
        selectedOptions: updatedSelectedOptions,
      });
    }
  }

  get isSaveBehaviouralFuncations(): boolean {
    return this.stepNumber === 3;
  }

  submit() {
    if (this.isSaveBehaviouralFuncations) {
      const payload = {
        caseBehaviorId: this.behavior.id,
        isAssessedFunctions:
          this.functionalAssessmentForm.value.isAssessedFunctions,
        behaviorFunctionIds:
          this.functionalAssessmentForm.value.selectedOptions,
      };

      this.saveBehaviouralfuncations(payload);
    } else {
      const currentControl = this.questions.at(this.currentQuestion).value;
      if (currentControl.functionalAssessmentAnswerId) {
        const payload = {
          caseBehaviorId: this.behavior.id,
          functionalAssessmentAnswers:
            this.functionalAssessmentForm.value.questions,
        };

        this.saveBehaviouralAssessment(payload);
      }
    }
  }
  isCurrentStepValid(): boolean {
    switch (this.stepNumber) {
      case 0:
        return (
          this.questions.length > 0 &&
          this.questions.at(this.currentQuestion).valid
        );
      case 1: {
        const { isLevelEscap, levelEscape } =
          this.functionalAssessmentForm.value;

        if (isLevelEscap && !levelEscape) return false;

        return true;
      }
      case 2: {
        const { isLevelEscap, levelEscape, isLevelAttention, levelAttention } =
          this.functionalAssessmentForm.value;

        if (isLevelAttention > 0 && !levelAttention) return false;
        else if (isLevelEscap > 0 && isLevelAttention > 0) {
          if (!levelEscape || !levelAttention) {
            return false; // Condition fails
          }
        }
        return true;
      }
      case 3:
        return this.functionalAssessmentForm.value.selectedOptions.length > 0;
      default:
        return false;
    }
  }
  goToNext() {
    switch (this.stepNumber) {
      case 0: {
        const currentControl = this.questions.at(this.currentQuestion).value;
        if (currentControl.functionalAssessmentAnswerId) {
          if (this.currentQuestion < this.fbaQuestionList.length - 1) {
            this.currentQuestion++;
            if (this.currentQuestion === this.fbaQuestionList.length - 1) {
              this.isFinalStep = true;
            } else {
              this.saveForLater(true);
            }
          } else {
            this.stepNumber = 3;
            this.isFinalStep = true;
          }
        }
        break;
      }
      case 1: {
        if (this.functionalAssessmentForm.value.levelEscape) {
          this.getLevelFuncations(
            BehaviourFunction.ESCAPE_AVOIDANCE,
            this.functionalAssessmentForm.value.levelEscape
          );
        }
        this.stepNumber = this.functionalAssessmentForm.value.isLevelAttention
          ? 2
          : 3;
        this.isFinalStep = this.functionalAssessmentForm.value.isLevelAttention
          ? false
          : true;
        break;
      }
      case 2: {
        if (this.functionalAssessmentForm.value.levelAttention) {
          this.getLevelFuncations(
            BehaviourFunction.GAINING_ATTENTION,
            this.functionalAssessmentForm.value.levelAttention
          );
        }
        this.stepNumber = 3;
        this.functionalAssessmentForm.patchValue({
          isAssessedFunctions: true,
        });
        this.isFinalStep = true;
        break;
      }
      case 3: {
        this.isFinalStep = true;
      }
    }
  }

  goToPre() {
    this.isFinalStep = false;
    switch (this.stepNumber) {
      case 0: {
        if (this.currentQuestion > 0) {
          this.currentQuestion--;
        } else {
          this.stepNumber = 0;
          this.currentQuestion = 0;
        }
        break;
      }
      case 1: {
        this.stepNumber = 0;
        this.currentQuestion = this.fbaQuestionList.length - 1;
        this.isFinalStep = true;
        break;
      }
      case 2: {
        if (this.functionalAssessmentForm.value.isLevelEscap) {
          this.stepNumber = 1;
          this.isFinalStep = false;
        } else {
          this.stepNumber = 0;
          this.currentQuestion = this.fbaQuestionList.length - 1;
          this.isFinalStep = true;
        }
        break;
      }
      case 3: {
        if (this.functionalAssessmentForm.value.isLevelAttention) {
          this.stepNumber = 2;
          this.isFinalStep = false;
        } else if (this.functionalAssessmentForm.value.isLevelEscap) {
          this.stepNumber = 1;
          this.isFinalStep = false;
        } else {
          this.stepNumber = 0;
          this.isFinalStep = true;
        }
      }
    }
  }
  resetPage() {
    this.functionalAssessmentForm.reset();
    this.currentQuestion = 0;
    this.stepNumber = 0;
    this.isFinalStep = false;
  }

  onCancel() {
    this.resetPage();
    const drawer = this.drawerService.getDrawerRef(DRAWER_IDS.FBA);
    drawer?.close({
      assemenetData: !this.isUpdated ? this.behaviourAssessment : null,
    });
    // this.drawerService.closeDrawer(DRAWER_IDS.FBA);
  }

  saveBehaviouralfuncations(payload: BehaviorFuncation) {
    this.loaderService.show();
    const operation$ = this.insightService.submitBehaviourFuncation(payload);
    operation$
      .pipe(
        take(1),
        takeUntil(this.destroy$),
        finalize(() => {
          this.loaderService.hide();
        })
      )
      .subscribe({
        next: () => {
          this.isUpdated = true;
          this.commonService.notify(
            'success',
            `The behavior screener has been saved.`
          );
          this.insightService.assessmentSubject.next([]);
          this.onCancel();
        },
        error: error => {
          this.loaderService.hide();
          this.handleError(error);
        },
      });
  }

  saveBehaviouralAssessment(
    payload: FunctionalAssessmentModelResponse,
    isNext = false
  ) {
    if (isNext) {
      this.loaderService.hide();
    } else {
      this.loaderService.show();
    }
    const operation$ = this.insightService.submitBehaviouralAssessment(payload);
    operation$.pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: () => {
        if (!isNext) {
          this.commonService.notify(
            'success',
            `The behavior screener has been saved.`,
            '',
            '400px',
            'top',
            800
          );
        }
        if (this.currentQuestion === 15 && this.stepNumber === 0) {
          this.insightService.assessmentSubject.next(this.behaviourAssessment);
          setTimeout(() => {
            this.getGraphData();
          }, 800);
        } else {
          if (!isNext) {
            this.resetPage();
            const drawer = this.drawerService.getDrawerRef(DRAWER_IDS.FBA);
            drawer?.close({
              assemenetData: null,
            });
          }
        }
        this.loaderService.hide();
      },
      error: error => {
        this.loaderService.hide();
        if (!isNext) {
          this.handleError(error);
        }
      },
    });
  }

  checkActivityLevel() {
    return _.orderBy(
      _.filter(this.graphData, item =>
        [
          BehaviourFunction.ESCAPE_AVOIDANCE as string,
          BehaviourFunction.GAINING_ATTENTION as string,
        ].includes(item.behaviourFunctionName)
      ),
      ['score'],
      ['desc']
    );
  }

  updateFormWithScore(
    result: BehaviouralAssessmentGraphData[],
    behaviourFunction: string,
    formKey: string,
    value: boolean
  ) {
    const filteredData = _.filter(result, item =>
      [behaviourFunction as string].includes(item.behaviourFunctionName)
    );

    if (filteredData.length > 0) {
      this.functionalAssessmentForm.patchValue({
        [formKey]: value,
      });
    }
  }

  getGraphData() {
    this.loaderService.show();
    this.insightService
      .getBehvaiourGraphData(this.behavior.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          if (response.result) {
            this.graphData = response.result;
            const sortedData = _.orderBy(
              _.filter(this.graphData, item => item.isSystemSuggested),
              ['score'],
              ['desc']
            );
            const selectedOptions = sortedData.map(data => {
              return _.chain(this.BehaviourFunctionList)
                .filter(record => record.value === data.behaviourFunctionName) // Match whole value instead of includes
                .map('id')
                .value();
            });
            this.functionalAssessmentForm.patchValue({
              selectedOptions: _.flatten(selectedOptions), // Combine results from all iterations
            });

            // getting for peer adult level question
            const result = _.orderBy(
              _.filter(sortedData, item =>
                [
                  BehaviourFunction.ESCAPE_AVOIDANCE as string,
                  BehaviourFunction.GAINING_ATTENTION as string,
                ].includes(item.behaviourFunctionName)
              ),
              ['score'],
              ['desc']
            );
            if (result.length > 0) {
              const behaviourFunctions = {
                hasEscapeAvoidance: result.some(
                  item =>
                    item.behaviourFunctionName ===
                    BehaviourFunction.ESCAPE_AVOIDANCE
                ),
                hasGainingAttention: result.some(
                  item =>
                    item.behaviourFunctionName ===
                    BehaviourFunction.GAINING_ATTENTION
                ),
              };
              // Update form for each behavior function
              Object.entries(behaviourFunctions).forEach(([key, exists]) => {
                if (exists) {
                  const behaviourType =
                    key === 'hasEscapeAvoidance'
                      ? BehaviourFunction.ESCAPE_AVOIDANCE
                      : BehaviourFunction.GAINING_ATTENTION;

                  const formKey =
                    key === 'hasEscapeAvoidance'
                      ? 'isLevelEscap'
                      : 'isLevelAttention';

                  this.updateFormWithScore(
                    result,
                    behaviourType,
                    formKey,
                    true
                  );
                }
              });

              this.stepNumber = this.functionalAssessmentForm.value.isLevelEscap
                ? 1
                : this.functionalAssessmentForm.value.isLevelAttention
                  ? 2
                  : 3;
              this.isFinalStep = false;
            } else {
              this.stepNumber = 3;
              this.isFinalStep = true;
            }
          }
          this.loaderService.hide();
        },
      });
  }

  private handleError({ errors, message }: ErrorResponse): void {
    const errorMessages = errors.map(
      err => err.description || err.detailedMessage
    );
    this.commonService.notify('error', errorMessages, message);
  }

  addIsSelected(
    questions: FunctionalAssessmentQuestion[],
    selectedAnswers: FunctionalAssessmentModelAnswer[]
  ) {
    return questions.map(question => {
      // Check if the question has selected answers
      const selectedAnswer = selectedAnswers.find(
        selected => selected.functionalAssessmentQuestionId === question.id
      );

      // Update the answers with the `isSelected` property
      question.functionalAssessmentAnswers =
        question.functionalAssessmentAnswers.map(answer => ({
          ...answer,
          isSelected: selectedAnswer
            ? answer.id === selectedAnswer.functionalAssessmentAnswerId
            : false,
        }));

      return question;
    });
  }
  async print() {
    const updatedQuestions = this.addIsSelected(
      this.fbaQuestionList,
      this.behaviourAssessment
    );
    const factory = this.viewContainerRef.createComponent(PrintFbaComponent, {
      injector: this.injector,
    });
    const componentElement = factory.location.nativeElement;
    componentElement.style.display = 'none';
    this.isPrintLoading = true;
    await Promise.all([
      this.orgService
        .getOrganization(this.caseDetail?.student.organizationId)
        .toPromise(),
    ])
      .then(async ([orgRes]: [OrganizationModel | undefined]) => {
        let base64Image = '';
        if (orgRes && orgRes.logoUrl) {
          base64Image = await this.commonService.getBase64ImageFromUrl(
            orgRes.logoUrl
          );
        } else {
          base64Image = await this.commonService.getBase64ImageFromUrl(
            '/assets/images/logo.png'
          );
        }
        factory.instance.fbaData = {
          behaviorAssessmentList: updatedQuestions,
          logo: base64Image,
          caseDetail: this.caseDetail,
          graphData: this.behavior.behaviorAssessmentGraph,
          chartImage: this.chartImage,
          orgDetail: orgRes,
          assesupdatedDate: this.assesupdatedDate,
        };
        this.cd.detectChanges();
        this.waitForInitialization(factory).then(() => {
          factory.instance.printPDF();
        });
      })
      .catch(e => console.error(e))
      .finally(() => {
        this.isPrintLoading = false;
        this.cd.detectChanges();
      });
  }

  waitForInitialization(factory: ComponentRef<PrintFbaComponent>) {
    return new Promise<void>(resolve => {
      const interval = setInterval(() => {
        if (factory.instance.initialized) {
          clearInterval(interval);
          resolve();
        }
      }, 10);
    });
  }

  saveForLater(isNext = false) {
    const payload = {
      caseBehaviorId: this.behavior.id,
      functionalAssessmentAnswers:
        this.functionalAssessmentForm.value.questions.filter(
          (q: FunctionalAssessmentModelAnswer) =>
            q.functionalAssessmentAnswerId !== null
        ),
    };
    this.saveBehaviouralAssessment(payload, isNext);
  }
}
